var __TEMP__ = require('./_baseIsMap.js');var baseIsMap = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseUnary.js');var baseUnary = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_nodeUtil.js');var nodeUtil = __REQUIRE_DEFAULT__(__TEMP__);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = isMap;
